import * as yup from 'yup';

import { FORM_INPUT_ERROR_MSGS } from '../../../../../../../constants/errors';
import { msisdnValidationSimple, reportToDate, shortcode } from '../../../../../../../constants/validation';

export const filtersValidationSchema = yup.object().shape({
  from: yup
    .date()
    .required(FORM_INPUT_ERROR_MSGS.REQUIRED('starting date'))
    .typeError(FORM_INPUT_ERROR_MSGS.INVALID_FORMAT('starting date')),
  to: reportToDate,
  shortcodes: shortcode,
  msisdns: yup.array(msisdnValidationSimple)
});
